import { observer } from 'mobx-react'
import React, { useCallback, useMemo } from 'react'
import { View } from 'react-native'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import { Text } from 'react-native-paper'

export default observer(({ children, shouldHighlight = false, model }) => {
  const [expanded, setExpanded] = React.useState(false)

  const expand = useCallback(() => setExpanded(true), [])

  const hasError = useMemo(() => {
    return shouldHighlight && !model.filled
  }, [model, shouldHighlight])

  const collapse = useCallback((e) => {
    const target = e.currentTarget
    setTimeout(() => {
      if (!target.contains(document.activeElement) && !hasError) {
        setExpanded(false)
      }
    }, 1000)
  }, [])

  return (
    <div tabIndex="-1" onFocus={expand} onBlur={collapse}>
      <View>
        {!expanded && model.filled && (
          <View
            style={{
              backgroundColor: 'white',
              borderColor: commonColors.tertiaryLight,
              borderWidth: 1,
              borderRadius: 4,
              marginTop: 15,
              padding: 12,
              height: 60,
              justifyContent: 'center',
            }}
          >
            <Text
              style={{
                color: '#98A6AE',
                textTransform: !!model.address && 'uppercase',
                fontSize: model.address ? 12 : 16,
              }}
            >
              Address *
            </Text>
            {!!model.address && (
              <Text style={{ marginTop: 3, fontSize: 16 }}>
                {`${model.address}, ${model.city}, ${model.state} ${model.zip}`}
              </Text>
            )}
          </View>
        )}
      </View>
      {(expanded || !model.filled) && <View>{children}</View>}
    </div>
  )
})
